import './theme.scss';
import { Routes, Route } from "react-router-dom";
import { Login } from "./pages/login";
import { useState, version } from 'react'
import { Createhotel, Viewhotels, HotelView } from './pages/hotel'
import { ConstructEmployeePage, Addemployee } from './pages/employee';
import { ConstructEmployerPage, Addemployer } from './pages/employers/employerlist';
import { checkloggedinstatus } from "./pages/login"
import { Constructcheckinpage } from './pages/checkinpage';
import { useEffect } from 'react';
import Startpage from "./pages/Startpage";
import Navigatie from "./pages/nav";
import Application from './pages/application';
import MyData from './pages/mydata';
import Daystats from './pages/daystats';
import EmplopyeePage from './pages/EmplopyeePage';
import EmployerPage from './pages/employers/EmployerPage';
import NotFound from './pages/errorPage';
import MyCleaningTasks from './pages/mycleaningtasks';
import Rooms from './pages/Rooms';
import Roomtype from './pages/Roomtype';
import Cleaningtype from './pages/Cleaningtype';
import Regions from './pages/Regions';
import Rooster from './pages/Rooster';
import Dagstaten from './pages/Dagstaten';
import Cleaningtask from './pages/Cleaningtask';
import MyHolidayRequest from './pages/myholidayrequest'
import ComposeMessage from './pages/composeemailmessage'
import ComposeMessagelist from './pages/composeemailmessagelist'
import AssignCleaningTasks from './pages/AssignCleaningTasks';
import CheckInAtWork from './pages/checkinatwork';
import Activityreport from './pages/activityreport';
import General from './pages/General';
import Tarieven from './pages/tarieven';
import Routeinghome from './pages/route';
import Ciaw from './pages/ciaw';
import TriggersCaches from './pages/triggers-caches';
import TriggersReports from './pages/triggers-reports';
import Passwordreset from './pages/passwoordreset';
import { getversion, myData, getCheckinOrOutTime } from './dbconnector/connector';
import ViewCleaningAssignments from './pages/viewcleaningAssignments';
import Holidayrequests from './pages/holidayrequests'
import Weekschedule from './pages/weekschedule'
import HolidayCalendar from './pages/HolidayCalendar'
import Invoice from './pages/invoice'
import Loginlist from './pages/loginlist'
import Reset from './pages/reset';
import React from 'react';
import useDeviceDetection from './pages/useDeviceDetection';
import { useTranslation } from 'react-i18next';
import NotPresent from './pages/NotPresent';
import AddToOtherRooster from './pages/AddToOtherRooster';

var mobile = require('is-mobile');




function App() {

  const [loggedIn, setLoggedIn] = useState(false)
  const [email, setEmail] = useState('')
  const [rights, setRights] = useState('')
  const [user, setUser] = useState(undefined)
  const [checkindata, setCheckindata] = useState({});
  const [version, setVersion] = useState("undefined");
  const { t } = useTranslation();
  const [mylinkedHotelsArray, setmylinkedHotelsArray] = useState([]);

  const [coords, setCoords] = useState({});

  var devicetype = useDeviceDetection();
  var mobile = require('is-mobile');



  if (mobile()) {
    if (window.screen.width < 600) {
      import('./pages/css/App.mobilesmall.css')
    } else {
      import('./pages/css/App.mobile.css')
    }
  } else {
    import('./pages/css/App.css')
  }
  import('./pages/css/colorScheme.css')


  if (mobile()) {
    import('./pages/css/App.mobilesmall.css')
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function hardreload() {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });

    caches.keys().then((keyList) => {
      return Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        })
      );
    });

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  async function checkVersion() {
    const cookieVersion = getCookie("version");

    if (!cookieVersion) {
      return;
    }

    try {
      const response = await getversion();
      const apiVersion = String(response.version)
      setVersion(cookieVersion.trim());
      if (cookieVersion.trim() !== apiVersion.trim()) {
        setVersion(apiVersion.trim());
        // Update the cookie to the new version
        setCookie("version", apiVersion, 7); // Set for 7 days (adjust as needed)

        hardreload();
        window.location.reload();
      } else {
        ////console.log(`Version matches: ${cookieVersion}`);
      }
    } catch (err) {
      ////console.error("Error fetching version from API:", err);
    }
  }


  // Helper function to set a cookie
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
  }

  // Function to ensure 'version' cookie exists with default value of '0'
  function ensureVersionCookie() {
    const cookieVersion = getCookie("version");
    if (!cookieVersion) {
      ////console.log("Version cookie not found. Setting default version to '0'.");
      setCookie("version", "0", 7); // Set to 7 days or adjust as needed
    } else {
      ////console.log(`Version cookie exists: ${cookieVersion}`);
    }
  }

  // Run the function to ensure 'version' cookie exists
  ensureVersionCookie();



  // Set an interval to check version every 1 minute
  setInterval(checkVersion, 60 * 1000);
  // setInterval(checkVersion, 60);



  useEffect(() => {
    const tokenresponse = checkloggedinstatus(setLoggedIn)


    tokenresponse.then(response => {
      if (response) {
        if (response.email) {

          ////console.log(response)
          setRights(response.rights)
          setEmail(response.email);
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
          setEmail("");
        }
      } else {
        setLoggedIn(false);
        setEmail("");
      }
    })

    myData().then(res => {
      setUser(res)
    });
    const result = getCheckinOrOutTime();
    result.then(res => {


      if (res.status === 200) {
        setCheckindata(res)
        if (res.type === "work") {
          if (res.inout === "in") {
            ////console.log(res)
            setTime(res.time, "Check in:", res.hotel)
          } else if (res.inout === "out") {
            setTime(res.time, "Check out:")
          }
        } else if (res.type === "pause") {
          if (res.inout === "in") {
            setTime(res.time, "Pause in:", res.hotel)

          } else if (res.inout === "out") {
            setTime(res.time, "Pause out:", res.hotel)
          }
        }

      } else {
        // document.getElementById("checkoutlink").style.display = "none"
        // document.getElementById("checkinlink").style.display = "block"
        // document.getElementById("pause").style.display = "none"
        // document.getElementById("pauseout").style.display = "none"
      }


    })
    checkVersion();
  }, []);

  const setTime = (time, type, hotel = "") => {

    const timestring = new Date(time).toLocaleTimeString()
    //console.log(document.getElementById("time"))
    if (document.getElementById("time") !== null) {
      document.getElementById("time").innerText = hotel + " " + type + " " + timestring;
    }
  }
  useEffect(() => {
    //console.log("checkindata in app.js", checkindata)
    //console.log("is mobile: ", mobile(), "  rights = ", rights)
  }, [checkindata])

  return (
    <>


  {/* 2 ='Administrator'
      3 = 'Supervisor'
      1 = 'Cleaner'
      4 = 'overhead'
  */}


      <div id="mySHC">

        <div id="TopNavigatie" className="TopNavigatie"><Navigatie email={email} loggedin={loggedIn} setrights={setRights} rights={rights} translation={t}></Navigatie></div>
        {/* <div className="LeftMenu"> */}
        {/* <div className="LeftTop" href="/home"><a href="/" ><img src="./img/logo_stars.png" alt="" /></a></div> */}
        {/* </div> */}

      </div>
      <div className="App" id="App">
        {rights === 2 && !mobile() ? (
          <Routes>
            <Route path="/" element={<Application loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/ciaw" element={<Ciaw loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/createhotel" element={<Createhotel loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/hotels" element={<Viewhotels rights={rights} translation={t} />} />
            <Route path="/Rooms" element={<Rooms rights={rights} translation={t} />} />
            <Route path="/Roomtype" element={<Roomtype rights={rights} translation={t} />} />
            <Route path="/Cleaningtype" element={<Cleaningtype rights={rights} translation={t} />} />
            <Route path="/Cleaningtask" element={<Cleaningtask rights={rights} translation={t} />} />
            <Route path="/hotels/:id" element={<HotelView rights={rights} translation={t} />} />
            <Route path="/employees" element={<ConstructEmployeePage rights={rights} translation={t} />} />
            <Route path="/employers/employerlist" element={<ConstructEmployerPage rights={rights} translation={t} />} />
            <Route path="/create-employee" element={<Addemployee rights={rights} translation={t} />} />
            <Route path="/create-employer" element={<Addemployer rights={rights} translation={t} />} />
            <Route path="/mydata" element={<MyData rights={rights} translation={t} />} />
            <Route path="/checkins" element={<Constructcheckinpage rights={rights} translation={t} />} />
            <Route path="/activityreport" element={<Activityreport rights={rights} translation={t} />} />
            <Route path="/daystats" element={<Daystats rights={rights} translation={t} />} />
            <Route path="/employee/:id" element={<EmplopyeePage rights={rights} translation={t} />} />
            <Route path="/employer/:id" element={<EmployerPage rights={rights} translation={t} />} />
            <Route path="/AssignCleaningTasks" element={<AssignCleaningTasks rights={rights} translation={t} />} />
            <Route path="/tarieven" element={<Tarieven rights={rights} translation={t} />} />
            <Route path="/myholidayrequest" element={<MyHolidayRequest rights={rights} user={user} translation={t} />} />
            <Route path="/composeemailmessage/:id" element={<ComposeMessage rights={rights} user={user} translation={t} />} />
            <Route path="/composeemailmessagelist" element={<ComposeMessagelist rights={rights} user={user} translation={t} />} />
            <Route path="/holidayrequests" element={<Holidayrequests rights={rights} loggedinUser={user} translation={t} />} />
            <Route path="/general" element={<General rights={rights} loggedinUser={user} translation={t} />} />
            <Route path="/HolidayCalendar" element={<HolidayCalendar rights={rights} translation={t} />} />
            <Route path="/checkinatwork" element={<CheckInAtWork rights={rights} translation={t} />} />
            <Route path="/regions" element={<Regions rights={rights} translation={t} />} />
            <Route path="/rooster" element={<Rooster rights={rights} translation={t} />} />
            <Route path="/Dagstaten" element={<Dagstaten rights={rights} translation={t} />} />
            <Route path="/invoice" element={<Invoice rights={rights} translation={t} />} />
             <Route path="/loginlist" element={<Loginlist rights={rights} translation={t} />} />
            <Route path="/viewcleaningassignments" element={<ViewCleaningAssignments rights={rights} translation={t} />} />
            <Route path="/triggers-caches" element={<TriggersCaches loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/triggers-reports" element={<TriggersReports loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/NoShow" element={<NotPresent loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/AddToOtherRooster" element={<AddToOtherRooster loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="*" element={<NotFound translation={t} />} />
          </Routes>
        ) : rights === 3 && !mobile() ? (
          <Routes>
            <Route path="/" element={<ViewCleaningAssignments loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/mydata" element={<MyData rights={rights} translation={t} />} />
            <Route path="/checkins" element={<Constructcheckinpage rights={rights} translation={t} />} />
            <Route path="/mycleaningtasks" element={<MyCleaningTasks rights={rights} translation={t} checkindata={checkindata} />} />
            <Route path="/AssignCleaningTasks" element={<AssignCleaningTasks rights={rights} translation={t} />} />
            <Route path="/myholidayrequest" element={<MyHolidayRequest rights={rights} user={user} translation={t} />} />
            <Route path="/checkinatwork" element={<CheckInAtWork rights={rights} translation={t} />} />
            <Route path="/holidayrequests" element={<Holidayrequests rights={rights} loggedinUser={user} translation={t} />} />
            <Route path="/HolidayCalendar" element={<HolidayCalendar rights={rights} translation={t} />} />
            <Route path="/regions" element={<Regions rights={rights} translation={t} />} />
            <Route path="/rooster" element={<Rooster rights={rights} translation={t} />} />
            <Route path="/viewcleaningassignments" element={<ViewCleaningAssignments rights={rights} translation={t} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : rights === 4 && !mobile() ? (
          <Routes>
            <Route path="/" element={<ViewCleaningAssignments loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/employees" element={<ConstructEmployeePage rights={rights} translation={t} />} />
            <Route path="/mydata" element={<MyData rights={rights} translation={t} />} />
            <Route path="/checkins" element={<Constructcheckinpage rights={rights} translation={t} />} />
            <Route path="/employee/:id" element={<EmplopyeePage rights={rights} translation={t} />} />
            <Route path="/AssignCleaningTasks" element={<AssignCleaningTasks rights={rights} translation={t} />} />
            <Route path="/myholidayrequest" element={<MyHolidayRequest rights={rights} user={user} translation={t} />} />
            <Route path="/holidayrequests" element={<Holidayrequests rights={rights} loggedinUser={user} translation={t} />} />
            <Route path="/HolidayCalendar" element={<HolidayCalendar rights={rights} translation={t} />} />
            <Route path="/checkinatwork" element={<CheckInAtWork rights={rights} translation={t} />} />
            <Route path="/rooster" element={<Rooster rights={rights} translation={t} />} />
            <Route path="*" element={<NotFound translation={t} />} />
            <Route path="/viewcleaningassignments" element={<ViewCleaningAssignments rights={rights} translation={t} />} />
            <Route path="/NoShow" element={<NotPresent loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
            <Route path="/AddToOtherRooster" element={<AddToOtherRooster loggedIn={loggedIn} email={email} rights={rights} translation={t} />} />
          </Routes>
        ) : rights > 0 && mobile() ? ( //rights === 1 && 
          <Routes>
            <Route path="/" element={<CheckInAtWork rights={rights} translation={t} />} />
            <Route path="/home" element={<Routeinghome rights={rights} translation={t} />} />
            <Route path="/mydata" element={<MyData rights={rights} translation={t} />} />
            <Route path="/checkins" element={<Constructcheckinpage rights={rights} translation={t} />} />
            <Route path="/mycleaningtasks" element={<MyCleaningTasks rights={rights} translation={t} user={user} checkindata={checkindata} />} />
            if([2,3].includes(user.rights))
            {
              <Route path="/holidayrequests" element={<Holidayrequests rights={rights} loggedinUser={user} translation={t} />} />
            }
            <Route path="/myholidayrequest" element={<MyHolidayRequest rights={rights} user={user} translation={t} />} />
             <Route path="/weekschedule" element={<Weekschedule rights={rights} user={user} translation={t} />} />
            <Route path="/AssignCleaningTasks" element={<AssignCleaningTasks rights={rights} translation={t} />} />
            <Route path="/checkinatwork" element={<CheckInAtWork rights={rights} translation={t} />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : <Routes>
          <Route path="/" element={<Startpage email={email} loggedIn={loggedIn} rights={rights} translation={t} setLoggedIn={setLoggedIn} />} />
          <Route path="/login" element={<Login setLoggedIn={setLoggedIn} setEmail={setEmail} setRights={setRights} rights={rights} />} />
          <Route path="/passReset" element={<Passwordreset translation={t} />} />
          <Route path="/newPassword" element={<Reset translation={t} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>}

      </div>
      <div
        style={{
          position: "fixed",     // stays in place, even when scrolling
          bottom: "10px",
          height:"25px",
         // width:"100%",        // distance from bottom
          left: "10px",         // or left: "10px" if you want it on the left
          right: "10px",  
          zIndex: 9999,          // ensures it's on top of everything
          backgroundColor:'hsl(139, 23%, 16%)',
        }}
      >
        <p 
          style={{
          paddingTop:"5px",
          fontSize: "12px",
          color: "#ffffffff",
          textAlign: "center",
        }}>
        Sam-Assist : version {version}</p>
      </div>


    </>
  );
}

export default App;
